import { useState } from "react";
import { Label } from "../ui/label";

// ------- Printer type (per-terminal) -------
export function PrinterTypeSelector() {
  const [type, setType] = useState(() => {
    try { return localStorage.getItem("pos_printer_type") || "browser"; } catch { return "browser"; }
  });
  const [showGuide, setShowGuide] = useState(false);

  const choose = (v) => {
    setType(v);
    try { localStorage.setItem("pos_printer_type", v); } catch (e) { console.warn(e); }
  };

  const OPTIONS = [
    {
      key: "browser",
      title: "Navegador (PC / USB / LAN)",
      desc: "Usa el diálogo de impresión estándar. Ideal en Windows/Mac con impresora térmica ya instalada.",
    },
    {
      key: "bluetooth_rawbt",
      title: "Bluetooth (Android + RawBT)",
      desc: "Envía el ticket vía la app RawBT a tu impresora ESC/POS emparejada. Recomendado para tablets/celulares Android.",
    },
  ];

  return (
    <div data-testid="printer-type-selector">
      <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">
        Tipo de impresora
      </Label>
      <div className="text-[11px] text-slate-500 mb-2">
        Configuración por dispositivo (cada terminal recuerda su elección).
      </div>
      <div className="grid grid-cols-1 gap-2">
        {OPTIONS.map((o) => (
          <button
            key={o.key}
            onClick={() => choose(o.key)}
            className={`text-left px-4 py-3 rounded-sm border-2 transition-colors ${
              type === o.key
                ? "border-blue-600 bg-blue-50"
                : "border-slate-200 hover:border-slate-300"
            }`}
            data-testid={`printer-type-${o.key}`}
          >
            <div className={`text-sm font-bold ${type === o.key ? "text-blue-700" : "text-slate-800"}`}>
              {o.title}
            </div>
            <div className="text-[11px] text-slate-500 mt-0.5">{o.desc}</div>
          </button>
        ))}
      </div>

      {type === "bluetooth_rawbt" && (
        <div className="mt-3 bg-amber-50 border border-amber-200 rounded-sm p-3">
          <div className="text-[11px] font-bold uppercase tracking-wider text-amber-800">
            Requisito: instalar RawBT en Android
          </div>
          <p className="text-xs text-amber-900 mt-1">
            RawBT es la app puente gratuita que recibe el ticket desde el navegador y lo envía por Bluetooth a tu impresora ESC/POS (ej. JACL-P210).
          </p>
          <button
            type="button"
            onClick={() => setShowGuide((v) => !v)}
            className="mt-2 text-xs font-bold text-amber-800 underline"
            data-testid="printer-guide-toggle"
          >
            {showGuide ? "Ocultar guía" : "Ver guía de instalación"}
          </button>
          {showGuide && (
            <ol className="mt-2 text-xs text-amber-900 list-decimal list-inside space-y-1">
              <li>
                Abre Play Store y busca <b>RawBT</b>, o descarga desde{" "}
                <a
                  href="https://play.google.com/store/apps/details?id=ru.a402d.rawbtprinter"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline font-bold"
                >
                  este enlace
                </a>.
              </li>
              <li>Empareja tu impresora térmica en <b>Ajustes → Bluetooth</b> del celular.</li>
              <li>Abre RawBT → <b>Configuración → Conexión</b> → elige <b>Bluetooth</b> y selecciona tu impresora.</li>
              <li>
                En <b>Configuración → Impresora</b> ajusta el ancho de papel a <b>{"58"}mm o {"80"}mm</b> según tu modelo (P210 es 58mm).
              </li>
              <li>Haz una prueba desde RawBT (menú <b>Test print</b>) para confirmar.</li>
              <li>Vuelve a Banca POS y toca <b>Imprimir</b> en cualquier ticket: se abrirá RawBT y saldrá impreso automáticamente.</li>
            </ol>
          )}
        </div>
      )}
    </div>
  );
}
